import { createContext, RefObject, useContext } from 'react';

export type DashboardPageScrollContextValue = {
  scrollRef: RefObject<HTMLElement | null>;
};

const DashboardPageScrollContext = createContext<DashboardPageScrollContextValue | null>(null);

export function useDashboardPageScroll(): DashboardPageScrollContextValue | null {
  return useContext(DashboardPageScrollContext);
}

export default DashboardPageScrollContext;
